import ManualBillingDocumentDocumentReference from '@/generated/controls/manualBillingDocument/ManualBillingDocumentDocumentReference.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {},
  extends: ManualBillingDocumentDocumentReference
})
